require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./olive-oil-with-lemon-cake-chunks.json") })
        }
      }, "path---olive-oil-with-lemon-cake-chunks");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---olive-oil-with-lemon-cake-chunks!./.cache/json/olive-oil-with-lemon-cake-chunks.json
// module id = 486
// module chunks = 231608221292675